/* em-order-box.js — Marmix (Designer Tiles) sipariş kutusu.
   Canlı toplam (Area supplied + fiyat) ve min-adet zorlaması (istemci tarafı).
   Yalnız kapı açıkken yüklenir. Sunucu tarafı zorlama YOKTUR. */
(function () {
  'use strict';

  function formatArea(m2) {
    var s = m2.toFixed(3);
    if (s.indexOf('.') > -1) {
      s = s.replace(/0+$/, '').replace(/\.$/, '');
    }
    return s + ' m²';
  }

  function init(box) {
    var input = box.querySelector('input[name="quantity"]');
    var areaEl = box.querySelector('[data-em-total-area]');
    var priceEl = box.querySelector('[data-em-total-price]');
    var note = box.querySelector('[data-em-min-note]');
    var minus = box.querySelector('button[name="minus"]');
    if (!input || !areaEl || !priceEl) return;

    var boxM2 = parseFloat(box.getAttribute('data-box-m2'));
    var unit = parseInt(box.getAttribute('data-unit-price'), 10);
    var min = parseInt(box.getAttribute('data-min-qty'), 10) || 1;
    if (!isFinite(boxM2) || !isFinite(unit)) return; // fail-closed: uydurma yok

    var noteDefault = note ? note.textContent : '';
    var alertTimer = null;

    function flagMin() {
      if (!note) return;
      note.textContent = 'Minimum order is ' + min + ' boxes';
      note.classList.add('is-alert');
      if (alertTimer) clearTimeout(alertTimer);
      alertTimer = setTimeout(function () {
        note.textContent = noteDefault;
        note.classList.remove('is-alert');
      }, 4000);
    }

    function clamp() {
      var raw = input.value;
      var q = parseInt(raw, 10);
      if (!isFinite(q) || q < min) {
        q = min;
        if (String(q) !== raw) {
          input.value = q;
          if (raw !== '') flagMin();
        }
      }
      return q;
    }

    function render() {
      var q = clamp();
      areaEl.textContent = formatArea(q * boxM2);
      priceEl.textContent =
        typeof formatMoney === 'function' ? formatMoney(q * unit) : '';
      if (minus) {
        if (q <= min) minus.classList.add('disabled');
        else minus.classList.remove('disabled');
      }
    }

    // Varyant fiyat haritası (Liquid'den). Yoksa/bozuksa: mevcut unit korunur.
    var priceMap = null;
    var mapEl = box.querySelector('script[data-em-variant-prices]');
    if (mapEl) {
      try { priceMap = JSON.parse(mapEl.textContent); } catch (e) { priceMap = null; }
    }

    // Bu tema PUB_SUB_EVENTS.variantChange YAYINLAMAZ (pubsub.js kullanilmiyor).
    // VariantSelects.updateVariantInput() id input'una bubbling 'change' atar.
    var form = box.closest('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    if (idInput && priceMap) {
      idInput.addEventListener('change', function () {
        var p = priceMap[idInput.value];
        if (typeof p !== 'number' || !isFinite(p)) return; // fail-closed: uydurma yok
        unit = p;
        // Fiyat caption'ı (em-show-price) da seçilen varyantla eşlensin (Law 1: tek fiyat gerçeği)
        var caps = document.querySelectorAll('.em-show-price .price-item--regular, .em-variant-price .price-item--regular');
        if (typeof formatMoney === 'function') for (var ci = 0; ci < caps.length; ci++) caps[ci].textContent = formatMoney(p);
        render();
      });
    }

    // global.js kendi 'input'/'focusout' dinleyicilerini önce ekler (geçersiz → 1);
    // bizimkiler sonra çalışır ve min'e geri çeker.
    input.addEventListener('input', render);
    input.addEventListener('change', render);
    input.addEventListener('focusout', render);
    render();
  }

  function boot() {
    var boxes = document.querySelectorAll('[data-em-order-box]');
    for (var i = 0; i < boxes.length; i++) init(boxes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
